import {useAuthStore} from '~/stores/auth';

/**
 * Лениво подгружает профиль текущего пользователя один раз за сессию SPA,
 * до того как отрисуется страница. Без этого меню в личном кабинете на
 * первой отрисовке успевает показать «открытое» состояние без замков и без
 * пунктов `hideForClinicDoctors`, а после загрузки профиля моргает в
 * корректное состояние (см. useDoctorProfileGates: дефолты «всё открыто»).
 *
 * Глобальный middleware покрывает точки входа после логина
 * (`/profile-doctor/`, `/profile-doctor/edit/` и т.п.), но не загружает профиль
 * на публичных страницах.
 */
export default defineNuxtRouteMiddleware(async (to) => {
    if (import.meta.server) return;

    const authStore = useAuthStore();
    if (authStore.userProfileData) return;
    if (!authStore.isAuth || !authStore.userRole) return;

    const role = authStore.userRole;
    if (role !== 'doctor' && role !== 'clinic' && role !== 'client') return;

    const profileRoot = role === 'doctor'
        ? '/profile-doctor'
        : role === 'clinic'
            ? '/profile-clinic'
            : '/profile';
    if (to.path !== profileRoot && !to.path.startsWith(`${profileRoot}/`)) return;

    const {apiQuery} = useApi();
    try {
        const data = await apiQuery<{data: unknown}>(`/${role}/profile/`, 'GET', {});
        authStore.setUserProfileData(data.data);
    } catch (error) {
        console.error('Failed to load profile in personal-profile-load middleware:', error);
    }
});
